import React from 'react';
const facts = [{
  value: '60',
  label: 'Ready-to-teach sessions'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '24',
  label: 'Printable worksheets'
}, {
  value: '3',
  label: 'Lanes per skill'
}];
export function SocialProofBar() {
  return <section className="w-full border-b border-sand-line bg-sand" data-id="element-331" data-mp="29s316cobdhdb">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-332" data-mp="25uf2qznex6go">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-sand-line bg-sand-line sm:grid-cols-4" data-id="element-333" data-mp="32jmpuc3ojnmp">
          {facts.map(fact => <div key={fact.label} className="bg-white/80 px-4 py-6 text-center" data-id="element-334" data-mp="2xi756l5ezj4u">
              <div className="font-display text-3xl leading-none text-night sm:text-4xl" data-id="element-335" data-mp="2tglmgj678amq">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-bold uppercase tracking-widest text-night-muted" data-id="element-336" data-mp="1i2zz93jwgj3u">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}